import { styled } from '@mui/material';

export const AccountStyle = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '10px',
  borderRadius: '10px',
  backgroundColor: '#fafafa',
});
